import { Badge } from "react-bootstrap";

export const getCurrencyCode = (member) => {
  return "AED";
};

export const formatNumber = (num) => {
  let numStr = num.toString();
  let [integerPart, fractionalPart] = numStr.split(".");
  let lastThreeDigits = integerPart.slice(-3);
  let rest = integerPart.slice(0, -3);
  if (rest) {
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    integerPart = rest + "," + lastThreeDigits;
  } else {
    integerPart = lastThreeDigits;
  }
  return fractionalPart ? integerPart + "." + fractionalPart : integerPart;
};
export const getFullName = (member) => {
  let fullName = "";

  if (member && member.firstName) {
    fullName = "";
    fullName += fullName ? " " + member.firstName : member.firstName;
    fullName += fullName ? " " + member.lastName : member.lastName;
  }

  return fullName;
};

export const isTrue = (value) => {
  if (value === 1 || value === "1" || value === true || value === "true")
    return true;
  return false;
};

export const isEmpty = (data) => {
  if (
    data === undefined ||
    data === "undefined" ||
    data === null ||
    data === "null" ||
    data === ""
  )
    return true;
  return false;
};

export const isValidEmail = (email) => {
  if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email)) {
    return true;
  }
  return false;
};

export function upperCaseFirst(str) {
  if (!str) return "";

  const arr = str.split(" ");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
}

export function isActivityPaid(activity) {
  // If the main activity is marked as paid, it's paid
  if (activity.paidActivity === "1") {
    return true;
  }

  // Check if any type of participant has a fee
  const hasPaidParticipation =
    (activity.guestFeaturesSettings?.allowed === "1" &&
      activity.guestFeaturesSettings?.paidParticipation === "1") ||
    (activity.kidsFeaturesSettings?.allowed === "1" &&
      activity.kidsFeaturesSettings?.paidParticipation === "1") ||
    (activity.partnerFeaturesSettings?.allowed === "1" &&
      activity.partnerFeaturesSettings?.paidParticipation === "1");

  return hasPaidParticipation;
}
export function get120PercentOf(number) {
  return number * 1.2;
}

export function didCapacityReached(item) {
  // Check if capacityStats exists and has a 'total' field
  if (item.capacityType === "limited") {
    const capcityStats = item.capacityStats || {};

    // Check for the necessary values in capcityStats, falling back to defaults
    const allowed = capcityStats.total?.allowed || 0;
    const registeredConfirmed = capcityStats.total?.registeredConfirmed || 0;
    const registered = capcityStats.total?.registered || 0;

    // Check if the capacity is full or over 120% of the allowed capacity
    const isFull = allowed === registeredConfirmed;
    const isOverCapacity = registered >= 1.2 * allowed;
    console.log("here");
    // Return true if either condition is met
    return isFull || isOverCapacity;
  }
  return false;
}

export function checkParticipantsLimitReached(registration, activity) {
  // Calculate allowed participants from activity settings
  //console.log(registration,activity)
  let allowedParticipants = 1; // Member is always included

  if (activity.partnerFeaturesSettings?.allowed === "1") {
    allowedParticipants += 1;
  }

  if (activity.kidsFeaturesSettings?.allowed === "1") {
    allowedParticipants += activity.kidsFeaturesSettings.allowedNumbers || 0;
  }

  if (activity.guestFeaturesSettings?.allowed === "1") {
    allowedParticipants += activity.guestFeaturesSettings.allowedNumbers || 0;
  }

  // Calculate actual participants from registration
  let actualParticipants = 1; // Always count the main member

  if (registration.status === "1") {
    if (registration.partnerParticipating === "1") {
      actualParticipants += 1;
    }
    if (registration.kidsParticipating === "1") {
      actualParticipants += registration.NumberOfKidsParticipating;
    }
    if (registration.guestParticipating === "1") {
      actualParticipants += registration.NumberOfGuestParticipating;
    }
    if (
      registration.additionalRequests &&
      registration.additionalRequests.length > 0
    ) {
      for (let addRequest of registration.additionalRequests) {
        if (addRequest.status === "1") {
          if (addRequest.partnerParticipating === "1") {
            actualParticipants += 1;
          }
          if (addRequest.kidsParticipating === "1") {
            actualParticipants += addRequest.NumberOfKidsParticipating;
          }
          if (addRequest.guestParticipating === "1") {
            actualParticipants += addRequest.NumberOfGuestParticipating;
          }
        }
      }
    }
  }
  console.log("actual", actualParticipants, "allowed", allowedParticipants);
  // Return true if actual participants exceed allowed
  return actualParticipants >= allowedParticipants;
}

export function checkStatus(registration, statusType) {
  // Check if the registration object itself has the status as "1"
  if (
    registration[statusType] === "1" &&
    registration.additionalRequests &&
    registration.additionalRequests.length <= 0
  ) {
    return true;
  }

  // Check inside additionalRequests array
  if (
    registration &&
    registration.additionalRequests &&
    registration.additionalRequests.length > 0
  ) {
    if (registration[statusType] === "1") {
      return true;
    }
    for (let addRequest of registration.additionalRequests) {
      if (addRequest[statusType] === "1") {
        return true; // Return true if status is found
      }
    }
  }

  return false; // If no match is found, return false
}

export function checkStatusOfAll(registration) {
  // Check if the registration object itself has the status as "1"
  if (
    registration.status === "1" &&
    registration.additionalRequests &&
    registration.additionalRequests.length <= 0
  ) {
    return true;
  }

  // Check inside additionalRequests array
  if (
    registration &&
    registration.additionalRequests &&
    registration.additionalRequests.length > 0
  ) {
    if (registration.status !== "1") {
      return false;
    }
    return registration.additionalRequests.every((req) => req.status === "1")
      ? true
      : false;
  }

  return false; // If no match is found, return false
}
export function getRemainingGuestCount(activity, registration) {
  if (!activity || !activity.guestFeaturesSettings) {
    return 0; // Return 0 if activity or settings are missing
  }

  const allowedGuests = activity.guestFeaturesSettings.allowedNumbers || 0; // Max allowed guests
  let registeredGuests = 0;

  // Count guests from the main registration
  if (registration && registration.NumberOfGuestParticipating) {
    registeredGuests += registration.NumberOfGuestParticipating;
  }

  // Count guests from additional requests if any
  if (
    registration &&
    registration.additionalRequests &&
    registration.additionalRequests.length > 0
  ) {
    for (let addRequest of registration.additionalRequests) {
      if (addRequest.NumberOfGuestParticipating) {
        registeredGuests += addRequest.NumberOfGuestParticipating;
      }
    }
  }

  // Calculate remaining guest slots
  const remainingGuests = allowedGuests - registeredGuests;

  return remainingGuests > 0 ? remainingGuests : 0; // Ensure no negative values
}
export function getNotConfirmedGuestCount(activity, registration) {
  if (!activity || !activity.guestFeaturesSettings) {
    return 0; // Return 0 if activity or settings are missing
  }

  const allowedGuests = activity.guestFeaturesSettings.allowedNumbers || 0; // Max allowed guests
  let registeredGuests = 0;

  // Count guests from the main registration
  if (
    registration &&
    registration.NumberOfGuestParticipating &&
    registration.status === "1"
  ) {
    registeredGuests += registration.NumberOfGuestParticipating;
  }

  // Count guests from additional requests if any
  if (
    registration &&
    registration.additionalRequests &&
    registration.additionalRequests.length > 0
  ) {
    for (let addRequest of registration.additionalRequests) {
      if (addRequest.status === "1") {
        if (addRequest.NumberOfGuestParticipating) {
          registeredGuests += addRequest.NumberOfGuestParticipating;
        }
      }
    }
  }

  // Calculate remaining guest slots
  const remainingGuests = allowedGuests - registeredGuests;

  return remainingGuests > 0 ? remainingGuests : 0; // Ensure no negative values
}
export function getRemainingKidsCount(activity, registration) {
  if (!activity || !activity.kidsFeaturesSettings) {
    return 0; // Return 0 if activity or settings are missing
  }

  const allowedGuests = activity.kidsFeaturesSettings.allowedNumbers || 0; // Max allowed guests
  let registeredGuests = 0;

  // Count guests from the main registration
  if (registration && registration.NumberOfKidsParticipating) {
    registeredGuests += registration.NumberOfKidsParticipating;
  }

  // Count guests from additional requests if any
  if (
    registration &&
    registration.additionalRequests &&
    registration.additionalRequests.length > 0
  ) {
    for (let addRequest of registration.additionalRequests) {
      if (addRequest.NumberOfKidsParticipating) {
        registeredGuests += addRequest.NumberOfKidsParticipating;
      }
    }
  }

  // Calculate remaining guest slots
  const remainingGuests = allowedGuests - registeredGuests;

  return remainingGuests > 0 ? remainingGuests : 0; // Ensure no negative values
}

export function getNotConfirmedKidsCount(activity, registration) {
  if (!activity || !activity.kidsFeaturesSettings) {
    return 0; // Return 0 if activity or settings are missing
  }

  const allowedGuests = activity.kidsFeaturesSettings.allowedNumbers || 0; // Max allowed guests
  let registeredGuests = 0;

  // Count guests from the main registration
  if (
    registration &&
    registration.NumberOfKidsParticipating &&
    registration.status === "1"
  ) {
    registeredGuests += registration.NumberOfKidsParticipating;
  }

  // Count guests from additional requests if any
  if (
    registration &&
    registration.additionalRequests &&
    registration.additionalRequests.length > 0
  ) {
    for (let addRequest of registration.additionalRequests) {
      if (addRequest.status === "1") {
        if (addRequest.NumberOfKidsParticipating) {
          registeredGuests += addRequest.NumberOfKidsParticipating;
        }
      }
    }
  }

  // Calculate remaining guest slots
  const remainingGuests = allowedGuests - registeredGuests;

  return remainingGuests > 0 ? remainingGuests : 0; // Ensure no negative values
}

export function isActivityFree(activity) {
  // Check if the main activity is free
  const isMainFree =
    activity.paidActivity === "0" || activity.participationFee === 0;

  // Function to check if a feature setting (partner, guest, kid) is free
  function isFeatureFree(featureSettings) {
    return (
      featureSettings?.allowed === "0" ||
      featureSettings?.paidParticipation === "0"
    );
  }

  // Check if partners, guests, and kids are either not allowed or free
  const isPartnerFree = isFeatureFree(activity.partnerFeaturesSettings);
  const isGuestFree = isFeatureFree(activity.guestFeaturesSettings);
  const isKidFree = isFeatureFree(activity.kidsFeaturesSettings);

  // Activity is free only if all conditions are met
  return isMainFree && isPartnerFree && isGuestFree && isKidFree;
}

export function isAnyOtherAllowed(activity) {
  // Function to check if a feature setting allows participation
  function isFeatureAllowed(featureSettings) {
    return featureSettings?.allowed === "1";
  }

  // Check if any other than the member is allowed
  return (
    isFeatureAllowed(activity.partnerFeaturesSettings) ||
    isFeatureAllowed(activity.guestFeaturesSettings) ||
    isFeatureAllowed(activity.kidsFeaturesSettings)
  );
}
export function isPartnerAllowed(activity) {
  return activity.partnerParticipation?.allowed === "1";
}

export function isGuestAllowed(activity) {
  return activity.guestParticipation?.allowed === "1";
}

export function isKidsAllowed(activity) {
  return activity.kidsParticipation?.allowed === "1";
}

export const getInitialItem = (item) => {
  const array = [];
  for (let i = 0; i < item.length; i++) {
    array.push({ label: item[i].title, value: item[i].title });
  }
  return array[0].value;
};

export const getObjectByTitle = (items) => {
  // console.log("Items ==> ", items)

  const array = [];
  if (items && items.length) {
    for (let i = 0; i < items.length; i++) {
      array.push({ label: items[i].title, value: items[i].title });
    }
  }

  return array;
};
const APPROVAL_STATUS_COLOR = {
  pending: "warning", // yellow/orange
  approved: "success", // green
  rejected: "danger", // red
};

const APPROVAL_STATUS_LABEL = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const ApprovalBadge = ({ status, value }) => {
  if (status === "not_applicable") {
    return "-";
  }

  const label =
    status === "approved" 
      ? (value ?? APPROVAL_STATUS_LABEL[status])
      : APPROVAL_STATUS_LABEL[status] || status || "Unknown";

  return (
    <Badge bg={APPROVAL_STATUS_COLOR[status] || "secondary"}>{label}</Badge>
  );
};
